<mat-drawer-container [class]="getDrawerContainerClass()">
  <mat-drawer #tourPointsDrawer mode="over" (closedStart)="onDrawerClosed()" position="end" class="drawer">
    <div class="grid grid-cols-2 gap-1 not-scrollable"> 
        <cal-group-tour-point-list [isVisible]="this.tourPointsDrawer?.opened || false" [class]="this.getContentClass()"/>
        @if(shouldShowDetailsDrawer()) {
          <cal-tour-points-details-list class="col-span-1"/>
        }
      </div>
  </mat-drawer>
</mat-drawer-container>